import { useUser } from 'stores/userStore';
import { claimEntity, useUserEntities } from 'stores/userEntitiesStore';
import { findOwnedUserEntity, isOwned, isPending } from 'actions/user_entities_actions';
import { useState } from 'react';
import { ClaimableEntityType } from 'queries';
import { useApplicationContainer } from 'containers/ApplicationContainer';

export interface ClaimEntityProps {
  entityType?: ClaimableEntityType;
  entityId: string;
}

export default function useClaimEntity({ entityType = ClaimableEntityType.Team, entityId }: ClaimEntityProps) {
  const [, { handleOpenLoginModal }] = useApplicationContainer();
  const user = useUser();
  const userEntities = useUserEntities();
  const ownedUserEntity = findOwnedUserEntity(userEntities.userEntities, entityType, entityId);
  const [pending, setPending] = useState(false);

  const isClaimPending = pending || (ownedUserEntity && isPending(ownedUserEntity));

  function handleClick() {
    if (!user.isLoggedIn) {
      handleOpenLoginModal();
    } else if (!user.canClaim) {
      alert(
        'You must be a coach or an admin to claim a team. If you are already logged in as an approved AD, there is no need to claim teams as you already have admin permissions for all teams in your school.'
      );
    } else {
      setPending(true);
      claimEntity(entityType, entityId);
    }
  }

  let message = `Claim this ${entityType}`;
  if (!user.isLoggedIn) {
    message = 'Login to claim';
  } else if (isClaimPending) {
    message = 'Claim pending';
  }

  return [
    {
      isLoggedIn: user.isLoggedIn,
      isOwner: ownedUserEntity && isOwned(ownedUserEntity),
      isPending: pending || (ownedUserEntity && isPending(ownedUserEntity)),
      message
    },
    { handleClick }
  ];
}
